/* TwoSet Custom: Market selector modal
   Snippet: snippets/custom-market-selector.liquid
*/

(function () {
  function setupMarketDialog(root) {
    const dialog = root.querySelector("[data-ts-market-dialog]");
    const openBtn = root.querySelector("[data-ts-market-open]");
    const closeBtns = root.querySelectorAll("[data-ts-market-close]");

    if (!dialog || !openBtn) return;

    openBtn.addEventListener("click", () => {
      if (dialog.showModal) {
        dialog.showModal();
      } else {
        dialog.setAttribute("open", "open");
      }
    });

    closeBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        if (dialog.close) {
          dialog.close();
        } else {
          dialog.removeAttribute("open");
        }
      });
    });

    dialog.addEventListener("click", (e) => {
      if (e.target === dialog) {
        if (dialog.close) {
          dialog.close();
        } else {
          dialog.removeAttribute("open");
        }
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".ts-market").forEach(setupMarketDialog);
  });
})();
